<app-navbar-style-two></app-navbar-style-two>
<app-seo-agency></app-seo-agency>

<section class="pt-5">
  <div class="container-fluid contact-banner mt-5">
    <h2 style="color: #ffffff">Pricing Plan</h2>
    <p style="color: #ffffff">Choose the Perfect Plan for Your Needs</p>
  </div>
</section>

<div class="container mt-4">
  <!-- <div class="row justify-content-center">
    <div class="col-12 col-md-2 mb-2" *ngFor="let step of steps; let i = index">
      <div
        class="step-box"
        [ngClass]="{ 'active-step': selectedStep === i + 1 }"
        (click)="goToStep(i + 1)"
      >
        <div class="step-label">Step {{ i + 1 }}</div>
        <div>{{ step.label }}</div>
      </div>
    </div>
  </div> -->

  <!-- <div class="row justify-content-center">
    <div class="col-lg-2 col-md-2" *ngFor="let step of steps; let i = index">
      <div class="services-item" [ngClass]="{ 'active-step': selectedStep === i + 1 }" (click)="goToStep(i + 1)">
        <div class="services-item-img text-center">
          <a><i class="bi custome-icon" [ngClass]="step.icon"></i></a>
          <div class="img-circle"></div>
        </div>
        <h6><a>{{ step.label }}</a></h6>
      </div>
    </div>
  </div> -->

  <div class="card-scroll-wrapper">
    <div class="row flex-nowrap">
      <div class="col-lg-2 col-md-2 col-5" *ngFor="let step of steps; let i = index">
        <div
          class="services-item"
          [ngClass]="{ 'active-step': selectedStep === i + 1 }"
          (click)="goToStep(i + 1)"
        >
          <div class="services-item-img text-center">
            <a><i class="bi custome-icon" [ngClass]="step.icon"></i></a>
            <div class="img-circle"></div>
          </div>
          <h6>
            <a>{{ step.label }}</a>
          </h6>
        </div>
      </div>
    </div>
  </div>

  <!-- Section content display -->
  <div class="mt-4">
    <div class="pricing-area pt-50 pb-100">
      <div class="container-fluid">
        <div class="text-center">
          <h2>Pricing Plan</h2>
          <p>Price & Plans <b>Packages</b></p>
        </div>

        <!-- <div class="price-width" *ngIf="selectedStep >= 1 && selectedStep <= 5">
        </div> -->

        <!-- <div class="price-width" *ngIf="selectedStep === 1">
          <div class="row">
            <div class="col-lg-4 col-sm-6">
              <div class="pricing-card">
                <div class="pricing-card-into color-bg1">
                  <i class="flaticon-banner pricing-icon color-1"></i>
                  <h3 class="color-1">STANDARD</h3>
                  <div class="price-rate">
                    <h2 class="color-1">$ 24.99</h2>
                    <span class="color-1">Launch Package</span>
                  </div>
                  <ul>
                    <li><i class="bx bx-check"></i> 1 DID Free</li>
                    <li><i class="bx bx-check"></i> 500 Pages</li>
                    <li><i class="bx bx-check"></i> Free Upgrade</li>
                    <li><del>OnBoarding/Training</del></li>
                    <li><del>Priority Support</del></li>
                  </ul>
                  <div
                    class="d-flex align-items-center justify-content-center mt-4"
                  >
                    <button class="btn start-btn">
                      <i class="bi bi-send-fill me-1"></i> Register Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="col-lg-4 col-sm-6">
              <div class="pricing-card">
                <div class="pricing-card-into color-bg2">
                  <i class="flaticon-mortgage-loan pricing-icon color-2"></i>
                  <h3 class="color-2">BUSINESS</h3>
                  <div class="price-rate">
                    <h2 class="color-2">$ 59.99</h2>
                    <span class="color-2">Growth Package</span>
                  </div>
                  <ul>
                    <li><i class="bx bx-check"></i>1 DID Free</li>
                    <li><i class="bx bx-check"></i>2000 Pages</li>
                    <li><i class="bx bx-check"></i>Free Upgrade</li>
                    <li><i class="bx bx-check"></i>OnBoarding/Training</li>
                    <li><del>Priority Support</del></li>
                  </ul>
                  <div
                    class="d-flex align-items-center justify-content-center mt-4"
                  >
                    <button class="btn start-btn">
                      <i class="bi bi-send-fill me-1"></i> Register Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="col-lg-4 col-sm-6 offset-sm-3 offset-lg-0">
              <div class="pricing-card">
                <div class="pricing-card-into color-bg3">
                  <i class="flaticon-processing pricing-icon color-3"></i>
                  <h3 class="color-3">ENTERPRISE</h3>
                  <div class="price-rate">
                    <h2 class="color-3">$ 129.99</h2>
                    <span class="color-3">Scale Package</span>
                  </div>
                  <ul>
                    <li><i class="bx bx-check"></i> 5 DID Free</li>
                    <li><i class="bx bx-check"></i> 5000 Pages</li>
                    <li><i class="bx bx-check"></i> Free Upgrade</li>
                    <li><i class="bx bx-check"></i> OnBoarding/Training</li>
                    <li><i class="bx bx-check"></i> Priority Support</li>
                  </ul>
                  <div
                    class="d-flex align-items-center justify-content-center mt-4"
                  >
                    <button class="btn start-btn">
                      <i class="bi bi-send-fill me-1"></i> Register Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div *ngIf="selectedStep === 1" class="pricing-container">
          <h3>Dialer Pricing Plan</h3>
          <p><strong>Insurance Dialer Packages</strong></p>

          <div class="included-features">
            <h4>Free Plan</h4>
            <p>
              All core features included — ideal for solo agents or testing.
            </p>
            <ul>
              <li>
                1 DID Free, on 5 lead numbers unlimited calling free (2000
                minutes per month)
              </li>
              <li>Call Recording</li>
              <li>Contact & Campaign Management</li>
              <li>Lead Tagging & Status Tracking</li>
              <li>Click-to-Call & Call Logging</li>
              <li>Basic Analytics Dashboard</li>
              <li>Softphone Access (Desktop & Mobile)</li>
              <li>Email & Chat Support</li>
            </ul>
            <p>
              <strong>Note:</strong> Usage limits apply. Additional usage will
              require a paid upgrade.
            </p>
          </div>

          <div class="faxing-section">
            <h4>Usage-Based Plan (Paid)</h4>
            <p>
              Perfect for teams scaling beyond free usage. Pricing is calculated
              based on actual usage volume.
            </p>

            <div class="responsive-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Up to 2000 Min</th>
                    <th>Tier 1 (2k to 25k min)</th>
                    <th>Tier 2 (25k to 100k)</th>
                    <th>Tier 3 (100k to 300k)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Service Charge / Minute</td>
                    <td>$0.005</td>
                    <td>$0.0025</td>
                    <td>$0.002</td>
                    <td>$0.00067</td>
                  </tr>
                  <tr>
                    <td>Recording</td>
                    <td>$0.001</td>
                    <td>$0.001</td>
                    <td>$0.001</td>
                    <td>$0.001</td>
                  </tr>
                  <tr>
                    <td>Storage</td>
                    <td>$0.0002</td>
                    <td>$0.0002</td>
                    <td>$0.0002</td>
                    <td>$0.0002</td>
                  </tr>
                  <tr>
                    <td>Transcription</td>
                    <td>$0.0125</td>
                    <td>$0.0125</td>
                    <td>$0.0125</td>
                    <td>$0.0125</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="note">
              Managed billing — you only pay for what you use. Custom contracts
              available for agencies, brokerages, and call centers.
            </p>

            <p class="contact-sales">
              Ready to scale?<br />
              <a href="#" class="contact-link">Contact Sales</a> to set up your
              usage-based dialer with real-time analytics, compliance tools, and
              dedicated onboarding.
            </p>
          </div>
        </div>

        <div *ngIf="selectedStep === 2" class="pricing-container">
          <h3>FAX Pricing Plan</h3>
          <p><strong>Per Account — Billed Monthly</strong></p>

          <div class="included-features">
            <h4>Included with Your Account</h4>
            <ul>
              <li>Onboarding & Training</li>
              <li>Priority Support</li>
              <li>Instant Setup – No Monthly Fees</li>
              <li>API Access Available</li>
            </ul>
          </div>

          <div class="faxing-section">
            <h4>Pay-As-You-Go Faxing</h4>
            <div class="responsive-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Fax Type</th>
                    <th>Rate</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Standard Faxing</td>
                    <td>$0.005 / page</td>
                    <td>Best for occasional or low-volume sending</td>
                  </tr>
                  <tr>
                    <td>Managed Faxing</td>
                    <td>$0.01 / optimized page</td>
                    <td>
                      Automatically compresses and formats documents for better
                      delivery & cost efficiency
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="note">
              We optimize file size and layout to reduce failed sends and
              control costs — especially helpful for large documents.
            </p>

            <p class="contact-sales">
              Need bulk sending, custom workflows, or enterprise fax
              automation?<br />
              <a href="#" class="contact-link">Contact Sales</a> to discuss
              high-volume plans or integration support.
            </p>
          </div>
        </div>

        <!-- <div class="container my-5" *ngIf="selectedStep === 3">
          <div class="position-relative text-center" >

            <p><strong>Per Account — Billed Monthly</strong></p>
            <div class="included-features feature-box pb-2">
              <h4>Included with Your Account</h4>
              <div class="row">
                <div class="col-12 col-md-6">
                  <ul class="list-unstyled">
                    <li>Onboarding & Training</li>
                    <li>Priority Support</li>
                  </ul>
                </div>
                <div class="col-12 col-md-6">
                  <ul class="list-unstyled">
                    <li>Instant Setup – No Monthly Fees</li>
                    <li>API Access Available</li>
                  </ul>
                </div>
              </div>
            </div>            
        
            <div class="contact-box d-flex justify-content-around align-items-center rounded">
              <div class="faxing-section">
                <h4> Pay-As-You-Go Faxing</h4>
                <div class="responsive-table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th>Fax Type</th>
                        <th>Rate</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Standard Faxing</td>
                        <td>$0.005 / page</td>
                        <td>Best for occasional or low-volume sending</td>
                      </tr>
                      <tr>
                        <td>Managed Faxing</td>
                        <td>$0.01 / optimized page</td>
                        <td>Automatically compresses and formats documents for better delivery & cost efficiency</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
            
                <p class="note">
                   We optimize file size and layout to reduce failed sends and control costs — especially helpful for large documents.
                </p>
            
                <p class="contact-sales">
                  Need bulk sending, custom workflows, or enterprise fax automation?<br />
                   <a href="#" class="contact-link">Contact Sales</a> to discuss high-volume plans or integration support.
                </p>
              </div>

            </div>
          </div>
        </div> -->

        <div *ngIf="selectedStep === 3" class="pricing-container">
          <h3>Email Marketing Pricing Plans</h3>
          <p><strong>Per user/month — Billed monthly</strong></p>

          <div class="included-features">
            <h4>Free Plan</h4>
            <p>Perfect for individuals or small teams getting started.</p>
            <ul>
              <li>Send up to 500 emails/SMTP/ per day (recommended)</li>
              <li>Basic Email Templates</li>
              <li>Contact List Management</li>
              <li>Email Scheduling</li>
              <li>Basic Reporting & Analytics</li>
              <li>Email Support</li>
              <li>Unlimited SMTP Integration</li>
              <li>Email API Integration</li>
            </ul>
          </div>

          <p class="note">
            Upgrade available for more contacts, advanced automation, and
            priority support.
          </p>

          <p class="contact-sales">
            Need advanced features, higher limits, or enterprise tools?<br />
            <a href="#" class="contact-link">Contact Sales</a> to learn about
            our Pro and Enterprise plans.
          </p>
        </div>

        <div *ngIf="selectedStep === 4" class="pricing-container">
          <h3>SMS Marketing Package</h3>
          <p><strong>Per SMS — Pay-as-you-go</strong></p>

          <div class="included-features">
            <h4>Key Features</h4>
            <ul>
              <li>High-delivery SMS gateway</li>
              <li>Real-time reporting and analytics</li>
              <li>Campaign scheduling</li>
              <li>Contact list management</li>
              <li>Opt-out compliance tools</li>
              <li>Bulk messaging support</li>
            </ul>
          </div>

          <div class="faxing-section">
            <h4>Pricing</h4>
            <div class="responsive-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Rate</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>SMS Marketing</td>
                    <td>$0.005 / SMS</td>
                    <td>Use your own API or SMTP account</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="note">
              Send promotional or transactional messages with high reliability
              and real-time tracking.
            </p>

            <p class="contact-sales">
              Need help with campaign setup, compliance, or custom workflows?<br />
              <a href="#" class="contact-link">Contact Sales</a> to learn more
              about enterprise messaging solutions.
            </p>
          </div>
        </div>

        <div *ngIf="selectedStep === 5" class="pricing-container">
          <h3>E-commerce Solution (Services & Products)</h3>
          <p><strong>$200/month</strong></p>
          <p>All-in-one eCommerce website solution — No hidden fees</p>

          <div class="included-features">
            <h4>What’s Included</h4>
            <ul>
              <li>Full-featured E-commerce Website</li>
              <li>Product & Service Listings</li>
              <li>Add to Cart & Checkout System</li>
              <li>Integrated Payment Gateway</li>
              <li>Order & Inventory Management</li>
              <li>Customer Account Dashboard</li>
              <li>Mobile-Responsive Design</li>
              <li>Basic SEO Optimization</li>
              <li>SSL Secure Hosting</li>
              <li>Email & Chat Support</li>
            </ul>
          </div>
        </div>

        <div *ngIf="selectedStep === 6" class="pricing-container">
          <h3>Social Media Management Tool Pricing</h3>
          <p><strong>Free Plan</strong></p>

          <div class="included-features">
            <h4>Included with Your Free Plan</h4>
            <ul>
              <li>100 Posts/Month</li>
              <li>Unlimited Social Channels</li>
              <li>Post Scheduling & Publishing</li>
              <li>Access to Dashboard & Calendar</li>
              <li>Email Support</li>
            </ul>
          </div>

          <div class="faxing-section">
            <h4>Additional Posting Options</h4>
            <div class="responsive-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Post Type</th>
                    <th>Rate</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Manual Posts Beyond Free Limit</td>
                    <td>$0.02 / post</td>
                    <td>For all extra posts outside the free limit</td>
                  </tr>
                  <tr>
                    <td>AI-Generated Posts (our AI)</td>
                    <td>$0.10 / post</td>
                    <td>Includes content creation & optimization</td>
                  </tr>
                  <tr>
                    <td>AI-Generated Posts (your ChatGPT API)</td>
                    <td>$0.03 / post</td>
                    <td>Use your own OpenAI API key for reduced cost</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="note">
              AI-generated content helps save time and improve engagement. You
              can bring your own API for more control over costs.
            </p>

            <div class="included-features">
              <h4>Custom Business Plan — Tailored for Agencies & Teams</h4>
              <ul>
                <li>Unlimited Posts</li>
                <li>Multi-user Team Access</li>
                <li>White-Label Dashboard (Your Branding)</li>
                <li>Dedicated Account Manager</li>
                <li>API Access & Custom Workflows</li>
                <li>Bulk Upload & CSV Scheduling</li>
                <li>Priority Support & Onboarding</li>
              </ul>
            </div>

            <p class="contact-sales">
              Want a personalized demo and pricing for your agency or team?<br />
              <a href="#" class="contact-link">Contact Sales</a> to get started.
            </p>
          </div>
        </div>

        <div *ngIf="selectedStep === 7" class="pricing-container">
          <h3>Simple Dialer Packages</h3>

          <div class="included-features">
            <h4>Free Plan</h4>
            <p>
              <strong
                >Perfect for solo agents or small teams starting out.</strong
              >
            </p>
            <ul>
              <li>1 Free DID Number</li>
              <li>Unlimited Calling on up to 5 Lead Numbers</li>
              <li>Preview Dialer Access</li>
              <li>Call Recording</li>
              <li>Lead Management & Tagging</li>
              <li>Click-to-Call & Call Logging</li>
              <li>Basic Analytics Dashboard</li>
              <li>Softphone Access (Desktop & Mobile)</li>
              <li>Email & Chat Support</li>
            </ul>
            <p class="note">
              Usage limits apply. Upgrade required for higher call volume or
              campaign automation.
            </p>
          </div>

          <div class="faxing-section">
            <h4>Custom Usage-Based Plan (Paid)</h4>
            <p>
              <strong
                >Ideal for teams or growing operations — you’re billed only for
                what you use.</strong
              >
            </p>

            <div class="responsive-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Unit Cost</th>
                    <th>Tier 0<br />(Up to 2,000 Min)</th>
                    <th>Tier 1<br />(Up to 25K)</th>
                    <th>Tier 2<br />(Up to 100K)</th>
                    <th>Tier 3<br />(Up to 300K)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Calling</td>
                    <td>Variable</td>
                    <td>$0.005/min</td>
                    <td>$0.0025/min</td>
                    <td>$0.002/min</td>
                    <td>$0.00067/min</td>
                  </tr>
                  <tr>
                    <td>Recording</td>
                    <td>$0.001/min</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                  <tr>
                    <td>Storage</td>
                    <td>$0.0002/min</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                  <tr>
                    <td>Transcription</td>
                    <td>$0.0125/min</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                    <td>✓</td>
                  </tr>
                  <tr>
                    <td>Preview Dialer</td>
                    <td>Included</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>✅</td>
                    <td>✅</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p class="note">
              Managed Billing: Pay only for the minutes and features you use<br />
              Custom Contracts: Available for high-volume teams, agencies & call
              centers
            </p>

            <p class="contact-sales">
              Ready to Scale?<br />
              <a href="#" class="contact-link">Contact Sales</a> for advanced
              setup, onboarding, and API access.
            </p>
          </div>
        </div>
      </div>

      <div class="pricing-shape">
        <div class="shape1">
          <img src="assets/img/shape/shape7.png" alt="Images" />
        </div>
        <div class="shape2">
          <img src="assets/img/shape/shape4.png" alt="Images" />
        </div>
        <div class="shape3">
          <img src="assets/img/shape/shape5.png" alt="Images" />
        </div>
        <div class="shape4">
          <img src="assets/img/shape/shape6.png" alt="Images" />
        </div>
        <div class="shape5">
          <img src="assets/img/shape/shape4.png" alt="Images" />
        </div>
        <div class="shape6">
          <img src="assets/img/shape/shape8.png" alt="Images" />
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-style-two></app-footer-style-two>
